import { createAction } from 'redux-starter-kit';
import { get, post } from '../../../utility/via-fetch';
import { requestStart, requestSucceded, requestFailed } from '../../domain/requests/RequestActions';
import { putAppConfig } from '../../domain/appConfig/appConfigActions';
import { adminRoutes } from '../../../utility/route-locations';

/**
 * An action that signifies a request to load some basic application config data
 */
export const loadAppConfig = createAction('LOAD_APP_CONFIG');

/**
 * A action that retrieves an application config object from the server
 * @param {string} configCode The unique identifier fo the config to retrieve E.G NEW_GROUP_TRIAL_LENGTH
 */
export function requestAppConfig(configCode) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(configCode));
    dispatch(loadAppConfig({ requestId, configCode }));
    try {
      const appConfig = await get(`/api/application-configurations/${configCode}`, undefined, { });
      dispatch(putAppConfig(appConfig));
      dispatch(requestSucceded(requestId));
    } catch (error) {
      dispatch(requestFailed(requestId)); // We failed.
    }
  };
}

/**
 * An action that signifies a request to update some basic application config data
 * Bynx admin user ONLY.
 */
export const saveAppConfig = createAction('SAVE_APP_CONFIG');

/**
 * A action that updates an application config object from the server
 * @param {string} configCode The unique identifier fo the config to retrieve E.G NEW_GROUP_TRIAL_LENGTH
 * @param {string} configValue The new value to assign to the configuration
 */
export function requestUpdateAppConfig(configName, configValue) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(`UPDATE_${configName}`));
    dispatch(saveAppConfig({ requestId, configName }));
    try {
      await post('/api/application-configurations', undefined, { applicationConfigCode: configName, applicationConfigValue: configValue });
      dispatch(putAppConfig({ configName, configValue }));
      dispatch(requestSucceded(requestId));
    } catch (error) {
      dispatch(requestFailed(requestId)); // We failed.
    }
  };
}

/**
 * An action that signifies a request to load some business application config data
 */
export const loadBusinessDetails = createAction('LOAD_BUSINESS_DETAILS');

/**
 * A action that retrieves an application config object from the server
 * This object cotains the data required ot produce business invoices for the application
 */
export function requestBusinessDetails() {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(loadBusinessDetails.toString()));
    dispatch(loadBusinessDetails(requestId));
    try {
      const businessDetails = await get('/api/application-configurations/business-details', undefined, {});
      dispatch(putAppConfig({ applicationConfigValue: businessDetails, applicationConfigCode: 'businessDetails' }));
      dispatch(requestSucceded(requestId));
    } catch (error) {
      dispatch(requestFailed(requestId)); // We failed.
    }
  };
}

/**
 * An action that signifies a request to update the business details for the application
 * Bynx admin user ONLY.
 */
export const saveBusinessDetails = createAction('SAVE_BUSINESS_DETAILS');

/**
 * A action that updates an application config object from the server
 * @param {object} businessDetails the object of busness details to save.
 * Maps to RESTAppBusinessDetail
 */
export function requestUpdateBusinessDetails(businessDetails, history) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(saveBusinessDetails.toString()));
    dispatch(saveBusinessDetails(requestId));
    try {
      await post('/api/application-configurations/business-details', undefined, businessDetails);
      dispatch(putAppConfig({ applicationConfigValue: businessDetails, applicationConfigCode: 'businessDetails' }));
      dispatch(requestSucceded(requestId));
      history.push(adminRoutes.admin_company_details);
    } catch (error) {
      dispatch(requestFailed(requestId)); // We failed.
    }
  };
}
